import { Component, Input, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import * as moment from "moment";
import { LocalStorageService } from 'ngx-webstorage';

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { EncodingDataService } from 'src/app/core/services/encoding-data.service';
import {AppConfigService} from "../../../../../../../core/services/config.service";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-historique-synthese',
  templateUrl: './historique-synthese.component.html',
  styleUrls: ['./historique-synthese.component.css']
})
export class HistoriqueSyntheseComponent implements OnInit {

  @Input() SYNTHESE_GLOBALE
  public listCompetences: any = [];
  public listNiveau: any;
  public typeVisualisation: any;
  public response: any;
  public typeFiche: any;
  public synthese: any;
  public estCalculer = false;
  public commentaire_mobilite: any;
  public note_global: string;
  public radioSignificative = false;
  public radioSignificativeState = true;
  public radioExceptionnelle = false;
  public radioExceptionnelleState = true;
  public radioNormale = false;
  public radioNormaleState = true;
  public radioInsuffisante = false;
  public radioInsuffisanteState = true;
  public nom: string;
  public prenoms: string;
  public structure: string;
  public poste: string;
  public anciennete_poste: string;
  public categorie: string;
  public anciennete_categorie: string;
  public date_debut_campagne: string;
  public matricule: string;
  public date_evaluation: string;
  public state_soumettre: any;
  public commentaire_nplus_un: string;
  public date_effectuee: string;
  public nom_effectuee: string;
  public date_acceptee: string;
  public nom_acceptee: string;
  public commentaire_agent: string;
  public commentaire_nplus_2: string;
  public date_approuvee: string;
  public nom_approuvee: string;
  public user: any;
  public entretien_id: any;
  public agent_id: any;
  public typeSauvegarde: any;
  public typeStatus: any;
  public vueActive: any;
  public proposition_mobilite_true: any = false;
  public proposition_mobilite_false: any = false;
  public proposition_mobilite: any;
  public proposition_mobilite_state = true;
  public commentaire_mobilite_state = true;
  public commentaire_hierarchie_n_plus_un_state = true;
  public commentaire_agent_state = true;
  public commentaire_hierarchie_n_plus_deux_state = true;
  public resultat_synthese_competence: any;
  public note_synthese_competence: any;
  public nbre_rubrique_evaluee_synthese_competence: any;
  public resultat_synthese_performance: any;
  public note_synthese_performance: any;
  public nbre_rubrique_evaluee_synthese_performance: any;
  public date_of_day: any;
  public API_URL: any;
  public FILE_URL: any;

  constructor(
    private _loader: LoadingBarService,
    private storage: LocalStorageService,
    private localStorage: EncodingDataService,
    private configService: AppConfigService,
  ) {
    this.API_URL = configService.get('HOST_API_ONLINE');
  }

  public ngOnInit(): void {
    /* Get URL details */
    const url = window.location.href;
    const split_url = url.split('/');
    this.vueActive = split_url[4];
    this.entretien_id = split_url[6];
    this.agent_id = split_url[7];
    this.typeFiche = split_url[9];
    this.typeSauvegarde = split_url[11];
    this.typeVisualisation = split_url[12];
    this.typeFiche = split_url[14];

    const data = this.storage.retrieve('user');
    this.user = JSON.parse(data);
    this.getFicheData();
    this.GetHistorique();
    if (this.vueActive === 'n-1' && this.typeVisualisation === 'evaluation') {
      this.proposition_mobilite_state = false;
      this.commentaire_mobilite_state = false;
      this.commentaire_hierarchie_n_plus_un_state = false;
    }
  }

  public GetHistorique(): void {
    const data = this.localStorage.getData('historique');
    this.response = JSON.parse(data);
  }

  public isChecked(item): void {
    this.proposition_mobilite = item;
  }

  public exportFiche(): void {
    this._loader.start();
    window.open(this.API_URL + 'fiche-historique/export/' + this.response?.campagne_id + '/' + this.response?.id + '/' + this.synthese?.type + '/fiche-complete', '_blank');
    this._loader.stop();
  }

  public getFicheData(): void {
    this.synthese = this.SYNTHESE_GLOBALE;
    // this.commentaire_agent = this.synthese?.commentaire_agent;
    this.commentaire_mobilite = this.synthese?.commentaire_mobilite;
    this.commentaire_nplus_un = this.synthese?.commentaire_nplus_1;
    this.commentaire_nplus_2 = this.synthese?.commentaire_nplus_2;

    this.nom = this.synthese?.nom;
    this.prenoms = this.synthese?.prenoms;
    this.matricule = this.synthese?.matricule;
    this.structure = this.synthese?.structure;
    this.poste = this.synthese?.poste;
    this.anciennete_poste = this.synthese?.anciennete_poste;
    this.date_of_day = moment().format("DD/MM/YYYY");;
    this.categorie = this.synthese?.categorie;
    this.anciennete_categorie = this.synthese?.anciennete_cat;
    this.date_evaluation = this.synthese?.effectue_le;
    if (this.synthese?.proposition_mobilite == 1) {
      this.proposition_mobilite_true = true;
    } else if (this.synthese?.proposition_mobilite == 0) {
      this.proposition_mobilite_false = true;
    } else {
      console.log('');
    }
    const synthese_competence = JSON.parse(this.synthese?.resultats.synthese_competence)
    const synthese_performance = JSON.parse(this.synthese?.resultats.synthese_performance)
    const synthese_savoir_etre = JSON.parse(this.synthese?.resultats.synthese_savoir_etre)
    const synthese_savoir_faire = JSON.parse(this.synthese?.resultats.synthese_savoir_faire)

    this.note_global = this.synthese?.resultats?.resultat_global;
    this.resultat_synthese_competence = this.synthese?.resultats?.resultat_synthese_competence;
    this.resultat_synthese_performance = this.synthese?.resultats?.resultat_synthese_performance;
    this.note_synthese_competence = synthese_competence?.["note"];
    this.nbre_rubrique_evaluee_synthese_competence = synthese_competence?.["nbre"];
    this.note_synthese_performance = synthese_performance?.["note"];
    this.nbre_rubrique_evaluee_synthese_performance = synthese_performance?.["nbre"];
    /* Checked Contribution Synthese */
    if (this.synthese?.resultats?.appreciation_global === 'Exceptionnelle') {
      this.radioExceptionnelle = true;
      this.radioExceptionnelleState = false;
      this.radioSignificativeState = true;
      this.radioNormaleState = true;
      this.radioInsuffisanteState = true;
      $('.label_exceptionnelle').css('color', '#0075FF');
      $('.label_significative').css('color', '#000');
      $('.label_normale').css('color', '#000');
      $('.label_insuffisante').css('color', '#000');
    } else if (this.synthese?.resultats?.appreciation_global === 'Significative') {
      this.radioSignificative = true;
      this.radioSignificativeState = false;
      this.radioExceptionnelleState = true;
      this.radioNormaleState = true;
      this.radioInsuffisanteState = true;
      $('.label_significative').css('color', '#0075FF');
      $('.label_exceptionnelle').css('color', '#000');
      $('.label_normale').css('color', '#000');
      $('.label_insuffisante').css('color', '#000');
    } else if (this.synthese?.resultats?.appreciation_global === 'Normale') {
      this.radioNormale = true;
      this.radioNormaleState = false;
      this.radioSignificativeState = true;
      this.radioExceptionnelleState = true;
      this.radioSignificativeState = true;
      this.radioInsuffisanteState = true;
      $('.label_normale').css('color', '#0075FF');
      $('.label_exceptionnelle').css('color', '#000');
      $('.label_significative').css('color', '#000');
      $('.label_insuffisante').css('color', '#000');
    } else if (this.synthese?.resultats?.appreciation_global === 'Insuffisante') {
      this.radioInsuffisante = true;
      this.radioInsuffisanteState = false;
      this.radioNormaleState = true;
      this.radioSignificativeState = true;
      this.radioExceptionnelleState = true;
      this.radioSignificativeState = true;
      $('.label_insuffisante').css('color', '#0075FF');
      $('.label_exceptionnelle').css('color', '#000');
      $('.label_significative').css('color', '#000');
      $('.label_normale').css('color', '#000');
    } else {
      this.radioInsuffisanteState = true;
      this.radioNormaleState = true;
      this.radioSignificativeState = true;
      this.radioExceptionnelleState = true;
      $('.label_insuffisante').css('color', '#000');
      $('.label_exceptionnelle').css('color', '#000');
      $('.label_significative').css('color', '#000');
      $('.label_normale').css('color', '#000');
    }

    this.date_effectuee = this.synthese?.effectue_le;
    this.date_approuvee = this.synthese?.approuve_le;
    this.date_acceptee = this.synthese?.accepte_le;
    // tslint:disable-next-line: max-line-length
    this.synthese?.agent_effectue_par == null ? this.nom_effectuee = '' : this.nom_effectuee = this.synthese?.agent_effectue_par.nom + ' ' + this.synthese?.agent_effectue_par?.prenoms;
    // tslint:disable-next-line: max-line-length
    this.synthese?.agent_approuve_par == null ? this.nom_approuvee = '' : this.nom_approuvee = this.synthese?.agent_approuve_par.nom + ' ' + this.synthese?.agent_approuve_par?.prenoms;
    // tslint:disable-next-line: max-line-length
    this.synthese?.agent_accepte_par == null ? this.nom_acceptee = '' : this.nom_acceptee = this.synthese?.agent_accepte_par.nom + ' ' + this.synthese?.agent_accepte_par?.prenoms;
    this.commentaire_agent = this.synthese?.commentaire_agent;
    this.estCalculer = true;
  }

  public getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  public async exportSynthese(): Promise<void> {
    this._loader.start();

    let docDefinition = {
      watermark: { text: `SIR`, fontSize: 100, angle: -70, color: '#ccc', opacity: 0.3, bold: true, italics: false },
      // userPassword: `${this.user?.data.matricule}`,
      // ownerPassword: `${this.user?.data.matricule}`,
      permissions: {
        printing: 'highResolution',
        modifying: false,
        copying: false,
        annotating: true,
        fillingForms: true,
        contentAccessibility: true,
        documentAssembly: true
      },
      content: [
        {
          columns: [
            {
              image: await this.getBase64ImageFromURL(
                `assets/img/logo_SIR.png`,
              ),
              width: 80,
              fontSize: 20,
              alignment: 'left',
              bold: true,
              margin: [0, 0, 0, 0],
            },
            [
              {
                text: 'ENTRETIEN INDIVIDUEL ANNUEL',
                fontSize: 12,
                bold: true,
                alignment: 'center',
                decoration: 'underline',
                margin: [0, 0, 0, 0],
                color: '#000'
              },
              {
                text: `Une copie de ce document doit être conservée par le salarié`,
                fontSize: 12,
                alignment: 'center',
                color: '#047886'
              },
            ],
          ],
        },
        {
          style: 'tableExample',
          table: {
            widths: [512],
            body: [
              [
                {
                  columnGap: 100,
                  border: [true, true, true, true],
                  fillColor: '#fff',
                  columns: [
                    [
                      { text: ['Nom : ', { text: `${this.synthese?.nom}`, alignment: 'left', italics: false, style: 'acceptation', color: '#0D6EFD' }], bold: true, alignment: 'left', },
                      { text: ['Structure : ', { text: `${this.synthese?.structure}`, alignment: 'left', italics: false, style: 'acceptation', color: '#0D6EFD' }], bold: true, alignment: 'left', },
                      { width: ['auto'], text: ['Poste : ', { text: `${this.synthese?.poste}`, alignment: 'left', italics: false, style: 'acceptation', color: '#0D6EFD' }], bold: true, alignment: 'left', },
                      // ],
                      // [
                      { text: ['Ancienneté : ', { text: `${this.synthese?.anciennete_poste}`, alignment: 'left', italics: false, style: 'acceptation', color: '#0D6EFD' }], bold: true, alignment: 'left', },
                    ],
                    [
                      { text: ['Prénoms : ', { text: `${this.synthese?.prenoms}`, alignment: 'right', italics: false, style: 'acceptation', color: '#0D6EFD' }], bold: true, alignment: 'right', },
                      { text: ['Mle : ', { text: `${this.synthese?.matricule}`, alignment: 'right', italics: false, style: 'acceptation', color: '#0D6EFD' }], bold: true, alignment: 'right', },
                      { text: ['Catégorie : ', { text: `${this.synthese?.categorie}`, alignment: 'right', italics: false, style: 'acceptation', color: '#0D6EFD' }], bold: true, alignment: 'right', },
                      { text: ['Ancienneté dans la catégorie : ', { text: `${this.synthese?.anciennete_cat}`, alignment: 'right', italics: false, style: 'acceptation', color: '#0D6EFD' }], bold: true, alignment: 'right', },
                      // { text: ['Au : ', { text: `${this.synthese?.date_of_day}`, alignment: 'right', italics: false, style: 'acceptation', color: '#0D6EFD' }], bold: true, alignment: 'right', },
                    ],
                    // [],
                  ]
                },
              ],

            ]
          },
          layout: {
            defaultBorder: false,
          }
        },
        {
          columns: [
            [
              {
                text: [`NOTE SYNTHESE COMPETENCES / NBRE RUBRIQUES : `, { text: `${this.note_synthese_competence ? this.note_synthese_competence : ''}/${this.nbre_rubrique_evaluee_synthese_competence ? this.nbre_rubrique_evaluee_synthese_competence : ''}`, color: '#0D6EFD' }],
                fontSize: 12,
                alignment: 'left',
                color: '#000'
              },
              {
                text: [`NOTE SYNTHESE PERFORMANCES / NBRE RUBRIQUES : `, { text: `${this.note_synthese_performance ? this.note_synthese_performance : ''}/${this.nbre_rubrique_evaluee_synthese_performance ? this.nbre_rubrique_evaluee_synthese_performance : ''}`, color: '#0D6EFD' }],
                fontSize: 12,
                bold: true,
                alignment: 'left',
                margin: [0, 10, 0, 0],
                color: '#000'
              },
              {
                text: [`SYNTHESE DES REALISATIONS ANNUELLES / APPRECIATION GLOBALE `, { text: `${this.note_global}`, color: '#0D6EFD' }],
                fontSize: 13,
                bold: true,
                alignment: 'left',
                margin: [0, 10, 0, 0],
                color: '#000'
              },
              {
                text: `Cette partie du document ne doit être complétée qu'après avoir renseigné les pages suivantes.`,
                fontSize: 10,
                alignment: 'left',
                color: '#000'
              },
            ],
          ],
        },
        {
          style: 'tableExample',
          table: {
            widths: [198, 198, 'auto', 20],
            body: [
              [
                { text: '', colSpan: 2 },
                {},
                { text: 'CONTRIBUTION', colSpan: 2 }, ''
              ],
              [
                {
                  text: `\n\n\n Par rapport aux missions et objectifs fixés, les réalisations :`,
                  rowSpan: 4,
                  fontSize: 10,
                  bold: true,
                  alignment: 'center',
                  // width: 300
                },
                {
                  text: 'Vont très largement au-délà des objectifs fixés et des missions confiées.'
                },
                {
                  text: 'Exceptionnelle',
                  fontSize: 10
                },
                {
                  text: `${this.synthese?.appreciation_global === 'Exceptionnelle' ? 'X' : ''}`,
                  bold: true,
                  alignment: 'center'
                },
              ],
              [
                '',
                {
                  text: 'Vont au-délà des objectifs fixés et des missions confiées.'
                },
                {
                  text: 'Significative'
                },
                {
                  text: `${this.synthese?.appreciation_global === 'Significative' ? 'X' : ''}`,
                  bold: true,
                  alignment: 'center'
                },
              ],
              [
                '',
                {
                  text: 'Répondent pleinement à tous les objectifs fixés et aux missions confiées.'
                },
                {
                  text: 'Normale / Conforme'
                },
                {
                  text: `${this.synthese?.appreciation_global === 'Normale' ? 'X' : ''}`,
                  bold: true,
                  alignment: 'center'
                },
              ],
              [
                '',
                {
                  text: 'Répondent partiellement aux objectifs fixés et aux missions confiées.'
                },
                {
                  text: 'Insuffisante'
                },
                {
                  text: `${this.synthese?.appreciation_global === 'Insuffisante' ? 'X' : ''}`,
                  bold: true,
                  alignment: 'center'
                },
              ]
            ]
          }
        },
        {
          style: 'tableExample',
          table: {
            widths: [458, '*', 170],
            body: [
              [
                { text: 'PROPOSITION POUR UNE MOBILITE : ', bold: true },
                {
                  columns: [
                    {
                      text: 'OUI',
                      alignment: 'center',
                      bold: true
                    },
                    {
                      text: 'NON',
                      alignment: 'center',
                      bold: true
                    }
                  ]
                }
              ],
              [
                '',
                {
                  columns: [
                    {
                      text: this.synthese.proposition_mobilite === 1 ? 'X' : '',
                      alignment: 'center',
                      bold: true
                    },
                    {
                      text: this.synthese.proposition_mobilite === 0 ? 'X' : '',
                      alignment: 'center',
                      bold: true
                    }
                  ]
                }
              ],
              [
                { text: 'COMMENTAIRES :', bold: true, colSpan: 2 },
                ``
              ],
              [
                { style: 'rowSpace', text: `${this.synthese?.commentaire_mobilite ? this.synthese?.commentaire_mobilite : ''}`, colSpan: 2 },
                {
                  text: 'Text area content goes here...',
                  colSpan: 3
                }
              ]
            ]
          }
        },
        {
          style: 'tableSynthese',
          table: {
            widths: [100, 295, 97],
            body: [
              [
                {
                  colSpan: 3,
                  text: 'COMMENTAIRE HIERARCHIE (N+1) (OBLIGATOIRE)',
                  bold: true
                },
                `${this.synthese.commentaire_nplus_1}`,
                ''
              ],
              [
                { style: 'rowSpace', text: `${this.synthese?.commentaire_nplus_1 ? this.synthese?.commentaire_nplus_1 : ''}`, colSpan: 3 },
                {
                  text: 'Text area content goes here...',
                  colSpan: 3
                }
              ],
              [
                {
                  text: `Date * :`,
                  bold: true
                },
                {
                  text: `Nom et Prénoms (N+1) :`,
                  bold: true
                },
                {
                  text: `Signature (N+1) :`,
                  bold: true,
                  alignment: 'center'
                }
              ],
              [
                {
                  text: `${this.date_of_day}`,
                  style: 'rowSpace',
                  bold: true
                },
                {
                  style: 'rowSpace',
                  text: `${this.synthese?.agent_n_plus_un?.nom ? this.synthese?.agent_n_plus_un?.nom : ''} ${this.synthese?.agent_n_plus_un?.prenoms ? this.synthese?.agent_n_plus_un?.prenoms : ''}`,
                  bold: true
                },
                {
                  text: `\n`, bold: true,
                  alignment: 'center'
                }
              ],
            ]
          }
        },
        {
          style: 'tableSynthese',
          table: {
            widths: [100, 295, 97],
            body: [
              [
                {
                  colSpan: 3,
                  text: 'COMMENTAIRE AGENT (OBLIGATOIRE)',
                  bold: true
                },
                `${this.synthese?.commentaire_agent}`,
                ''
              ],
              [
                { style: 'rowSpace', text: `${this.synthese?.commentaire_agent ? this.synthese?.commentaire_agent : ''}`, colSpan: 3 },
                {
                  text: 'Text area content goes here...',
                  colSpan: 3
                }
              ],
              [
                {
                  text: `Date * : `,
                  bold: true
                },
                {
                  text: `Nom et Prénoms (Agent) : `,
                  bold: true
                },
                {
                  text: 'Signature (Agent) : ',
                  bold: true,
                  alignment: 'center'
                }
              ],
              [
                {
                  text: `${this.date_of_day}`,
                  style: 'rowSpace',
                  bold: true
                },
                {
                  style: 'rowSpace',
                  text: `${this.synthese?.nom ? this.synthese?.nom : ''} ${this.synthese?.prenoms ? this.synthese?.prenoms : ''}`,
                  bold: true
                },
                {
                  text: '\n',
                  alignment: 'center'
                }
              ]
            ]
          }
        },
        {
          style: 'tableSynthese',
          table: {
            widths: [100, 295, 97],
            body: [
              [
                {
                  colSpan: 3,
                  text: 'COMMENTAIRE HIERARCHIE (N+2) (FACULTATIF)',
                  bold: true
                },
                `${this.synthese.commentaire_nplus_2}`,
                ''
              ],
              [
                { style: 'rowSpace', text: `${this.synthese.commentaire_nplus_2 ? this.synthese.commentaire_nplus_2 : ''}`, colSpan: 3 },
                {
                  text: 'Text area content goes here...',
                  colSpan: 3
                }
              ],
              [
                {
                  text: `Date * : `,
                  bold: true
                },
                {
                  text: `Nom et Prénoms (N+2) : `,
                  bold: true
                },
                {
                  text: `Signature (N+2) : `,
                  bold: true,
                  alignment: 'center'
                }
              ],
              [
                {
                  text: `${this.date_of_day}`,
                  style: 'rowSpace',
                  bold: true
                },
                {
                  style: 'rowSpace',
                  text: `${this.synthese?.agent_n_plus_deux?.nom ? this.synthese?.agent_n_plus_deux?.nom : ''} ${this.synthese?.agent_n_plus_deux?.prenoms ? this.synthese?.agent_n_plus_deux?.prenoms : ''}`,
                  bold: true
                },
                {
                  text: '\n',
                  alignment: 'center'
                }
              ]
            ]
          }
        }
      ],

      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },

        tableExample: {
          fontSize: 10,
          margin: [0, 15, 0, 5]
        },

        rowSpace: {
          margin: [0, 10, 0, 10],
        },

        header: {
          fontSize: 16,
          bold: true,
          alignment: 'center',
          width: 300
        },

        tableSynthese: {
          fontSize: 10,
          margin: [0, 0, 0, 8]
        },

        bold: {
          bold: true
        },

        quote: {
          italics: true,
        },

        small: {
          fontSize: 8
        },

        acceptation: {
          fontSize: 9,
          margin: [0, 10, 0, 10]
        }
      },

      // defaultStyle: {
      //   font: 'Poppins'
      // },

      footer: function (currentPage, pageCount) {
        return {
          columns: [
            {
              text: `Téléchargé le: ${new Date().toLocaleString()}`,
              alignment: 'left',
              margin: [10, 0, 0, 0],
              style: ['quote', 'small'],
            },
            {
              text: currentPage.toString() + '/' + pageCount,
              alignment: 'right',
              style: ['quote', 'small'],
              margin: [0, 0, 10, 0]
            }
          ]
        }
      }
    }

    // docDefinition.content.push(ACCEPTATION as any, SIGNATURE as any)

    // pdfMake.fonts = {
    //   Poppins: {
    //     normal: `${window.location.origin}/assets/fonts/Poppins/Poppins-Regular.ttf`,
    //     bold: `${window.location.origin}/assets/fonts/Poppins/Poppins-Bold.ttf`,
    //     italics: `${window.location.origin}/assets/fonts/Poppins/Poppins-Italic.ttf`,
    //   }
    // };

    pdfMake.createPdf(docDefinition).download(`FICHE_SYNTHESE_GLOBALE_${this.synthese?.matricule}_${this.synthese?.nom}_${this.synthese?.prenoms} `);

    this._loader.stop();
  }

}
